import styled from "styled-components";  
import { Link } from "react-router-dom";
import { Link as LinkScroll } from "react-scroll";

export const Button = styled(Link)`
    border-radius: 2px;
    background: ${({ primary }) => (primary ? "#A1AC9E" : "#690A62")};
    white-space: nowrap;
    padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
    color: ${({ dark }) => (dark ? "#000000" : "#fff")};
    font-size: ${({ fontBig }) => (fontBig ? "38px" : "24px")};
    outline: none;
    border: 1px solid #000;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.75s ease-in-out;
    text-decoration: none;
    font-weight: bold;

    margin: 5px;

    &:hover {
        transition: all 1s ease-in-out;
        color: ${({ dark }) => (dark ? "#ffffff" : "#000000")};
        background: ${({ primary }) => (primary ? "#690A62" : "#DCD5C9")};
    }
`;

export const ButtonS = styled(LinkScroll)`
    border-radius: 50px;
    background: ${({ primary }) => (primary ? "#DCD5C9" : "#690A62")};
    white-space: nowrap;
    padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
    color: ${({ dark }) => (dark ? "#DCD5C9" : "#fff")};
    font-size: ${({ fontBig }) => (fontBig ? "38px" : "24px")};
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.75s ease-in-out;
    text-decoration: none;
    font-weight: bold;

    &:hover {
        transition: all 1s ease-in-out;
        color: ${({ dark }) => (dark ? "#DCD5C9" : "#000000")};
        background: ${({ primary }) => (primary ? "#A1AC9E" : "#DCD5C9")};
    }
`;

export const ButtonOut = styled.a`
    border-radius: 50px;
    background: ${({ primary }) => (primary ? "#DCD5C9" : "#690A62")};
    white-space: nowrap;
    padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
    color: ${({ dark }) => (dark ? "#000000" : "#DCD5C9")};
    font-size: ${({ fontBig }) => (fontBig ? "38px" : "24px")};
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.75s ease-in-out;
    text-decoration: none;
    font-weight: bold;

    &:hover {
        transition: all 1s ease-in-out;
        background: ${({ primary }) => (primary ? "#A1AC9E" : "#A1AC9E")};
    }
`;

